import type { CatalogueEntry } from "../types";
import imageLight from "../images/land-use-land-cover.light.webp";
import imageDark from "../images/land-use-land-cover.dark.webp";

export const entry: CatalogueEntry = {
  slug: "land-use-land-cover",
  displayName: `Land Use Land Cover`,
  datasetProductCode: `LAND USE LAND COVER`,
  subtitle: `Cadastre (parcel)–level land use and land cover classification`,
  shortDescription: `Cadastre-level land use and land cover classification data across Australia, structured as three related tables (cover, forest, crop) joinable to Geoscape Cadastre via cadastre_polygon_pid.`,
  metadata: {
    dateAdded: 1778196186928,
    dataType: ["Aspatial"],
    theme: `Natural Environment`,
    totalFeatureCount: 8330199,
    updateFrequency: `Yearly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/lulc.html`,
  imageLight,
  imageDark,
  searchTags: `LULC Land Use Land Cover Agriculture Crop Forest Cadastre Carbon Biodiversity`,
  detail: () => import("../details/land-use-land-cover").then((m) => m.detail),
};

export default entry;
